import { ThemeContext } from '@emotion/core';
import { useContext } from 'react';
import { Theme } from 'ds';

export const useTheme = () => {
  return useContext(ThemeContext) as Theme;
};
